import env from "../config/env";

/**
 * Cookie di TRASPORTO del token di sessione tra i sottodomini .feinar.it (SEC-04).
 * Sostituisce il token nella query string: il login SSO lo imposta lato server e il
 * Portale lo legge qui; per il lancio di un'applicazione il Portale lo imposta lato JS
 * (ha gia il token in localStorage) prima di aprire la destinazione.
 * NON HttpOnly per definizione (lo legge il JS), Secure su HTTPS, vita breve, uso singolo.
 */
const COOKIE_NAME = "feinar_session";
const MAX_AGE_SECONDS = 60;

export function getTransportToken(): string | null {
  const match = document.cookie.match(
    new RegExp(`(?:^|;\\s*)${COOKIE_NAME}=([^;]+)`)
  );
  return match ? decodeURIComponent(match[1]) : null;
}

export function setTransportToken(token: string): void {
  const parts = [
    `${COOKIE_NAME}=${encodeURIComponent(token)}`,
    "path=/",
    `max-age=${MAX_AGE_SECONDS}`,
    "SameSite=Lax",
  ];
  if (env.COOKIE_DOMAIN) {
    parts.push(`domain=${env.COOKIE_DOMAIN}`);
  }
  if (window.location.protocol === "https:") {
    parts.push("Secure");
  }
  document.cookie = parts.join("; ");
}

export function clearTransportToken(): void {
  const parts = [`${COOKIE_NAME}=`, "path=/", "max-age=0"];
  if (env.COOKIE_DOMAIN) {
    parts.push(`domain=${env.COOKIE_DOMAIN}`);
  }
  document.cookie = parts.join("; ");
}
